module.exports = __webpack_public_path__ + "static/media/lock-ico.dbe73b50.svg";